import PartnersList from '../dataDisplay/PartnersList/PartnersList';
import { FloatingBox } from '../etc/LBox/LBox';
import { Divider } from 'oui';
import usePartners from '../../application/bloc/usePartners';
import useFooter from '../../application/hooks/useFooter';

import { Button, Spacer, TheFooter } from 'oui';

const Partners = () => {
  const { navigateOvertake, navigateOvertakePrivacy } = useFooter();
  const {
    activeCompList,
    toBeExposedCompList,
    compByLoanCategory,
    sendBeaconClkBtnLoanApp,
    isTodayRequested,
    showTerms,
  } = usePartners();

  const handleClickCtaBtn = (e: any) => {
    sendBeaconClkBtnLoanApp(e.target.innerHTML ?? '');

    showTerms();
  };

  const {
    CREDIT_L,
    HOUSE_L,
    JEONSE_L,
    CAR_L,
  } = compByLoanCategory ?? {};

  return (
    <>
      {activeCompList?.length > 0 && (
        <>
          <PartnersList title="함께하는 금융사" partners={activeCompList} />
          <Spacer size={'lg'} />
        </>
      )}

      {toBeExposedCompList?.length > 0 && (
        <>
          <PartnersList title="함께할 금융사" partners={toBeExposedCompList} />
          <Spacer size={'lg'} />
        </>
      )}

      {compByLoanCategory && (
        <>
          <Divider type={'contents'} />
          {CREDIT_L && CREDIT_L.length > 0 &&
            <>
              <PartnersList title="신용대출" partners={CREDIT_L} />
              <Spacer size={'lg'} />
            </>
          }
          {HOUSE_L && HOUSE_L.length > 0 &&
            <>
              <PartnersList title="주택담보대출" partners={HOUSE_L} />
              <Spacer size={'lg'} />
            </>
          }
          {JEONSE_L && JEONSE_L.length > 0 &&
            <>
              <PartnersList title="전세자금대출" partners={JEONSE_L} />
              <Spacer size={'lg'} />
            </>
          }
          {CAR_L && CAR_L.length > 0 &&
            <>
              <PartnersList title="자동차담보대출" partners={CAR_L} />
              <Spacer size={'lg'} />
            </>
          }
        </>
      )}

      {!isTodayRequested && (
        <FloatingBox>
          <Button
            configuration={'contained'}
            flexible={true}
            onClick={handleClickCtaBtn}
            children={'지금 비교하러 가기'}
          />
        </FloatingBox>
      )}

      <TheFooter
        type={'c'}
        onClickOvertake={navigateOvertake}
        onClickOvertakePrivacy={navigateOvertakePrivacy}
      />
    </>
  );
};

export default Partners;
